import { Button } from "@tento-ui/components/button/button";
import { DateTime } from "@tento-chrono";
import { Storybook } from "@tento-ui/ui/storybook";
import { BookingConfirmation } from "./booking-confirmation";

export class BookingConfirmationStoryBook extends Storybook.Default {
  title(): string {
    return "Booking Confirmation Modal";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Confirm booking (modal)",
        render: () =>
          Button.makeWithLight("Confirm your booking", {
            type: "primary",
            onClick: () => {
              const start = DateTime.utc
                .now()
                .ndt.date.withTime()
                .asUtc()
                .add({ days: 2, hrs: 16 });
              void BookingConfirmation.show({
                start,
                tzName: "America/Los_Angeles",
                username: "ada@example.com",
                slug: "coffee-chat",
              });
            },
          }),
      },
    ];
  }
}
